<template lang="pug">
  #section4.section
    #s4s1
      #s4s1a1.group
        // text group        
        #s4s1a1b1
          .fake.fake-header
          .block  
            .slide
              p.bold.text-right.small Este es un relato que es posible gracias a la participación de las víctimas directas e indirectas de&nbsp;
                span.green El Quemado.
          .fake.fake-footer
        #s4s1a1b2
          .fake.fake-header
          .block  
            .slide
              p.bold La narrativa que se presentó aquí es resultado de una investigación archivística, documental y testimonial hecha con rigor académico dentro  del marco del MVDF. La naturaleza de narrar un hecho traumático en el pasado conlleva no solo informar, sino también invitar a la reflexión crítica y a incluir más voces que puedan enriquecer dicha narrativa. Por lo anterior, es importante dejar claro que esta narrativa se tome como una de múltiples formas de recordar el pasado, honrando así a quienes en esta ocasión no tuvieron espacio para expresar su versión, pero que se espera encuentren un momento para hacerlo.
          .fake.fake-footer
        #s4s1a1b3
          .fake.fake-header
          .block  
            .slide
              p.bold.large Su lucha por recibir una reparación integral y digna conforme a sus derechos exigió que su historia fuera contada más allá de un monumento y se se construyera con un&nbsp;
                span.green Memorial Integral&nbsp;
                | compuesto por espacios públicos, con la finalidad de acercar su acceso a la educación y la cultura, así como el apoyo de herramientas digitales, investigación documental y el registro audiovisual del proceso de dicho Memorial.
          .fake.fake-footer
      #s4s1a2.group
        // text group        
        #s4s1a2b1
          .block  
            .text-slide
              p.small.bold.text-right El objetivo de este proyecto es no solo recordar el pasado, sino&nbsp; 
                span.green crear espacios y herramientas públicas&nbsp;
                | que nos permitan reducir el riesgo a que estas violencias vuelvan a ocurrir.
        #s4s1a2b2
          .block  
            .text-slide
              p.bold.large También parte de su reparación integral es el fortalecimiento de sus productividad agrícola para obtener autosuficiencia económica. Te invitamos a que acerques a la comunidad de El Quemado en la sección de Contacto y que también continúes explorando el Memorial Integral:
        #s4s1a2b3
          .block
            .row.button-list
              .col-12
                b-button.mx-3(variant="outline-light" href="https://mapa-mvdf.datacivica.org/" target="_blank") MEMORIAL DISPERSO
                b-button.mx-3(variant="outline-light" href="http://mvdf.datacivica.org/testimonios" target="_blank") TESTIMONIOS
                b-button.mx-3(variant="outline-light" href="http://mvdf.datacivica.org/" target="_blank") DOCUMENTAL
    
</template>
<script>
export default {
  name: "Section4"
}
</script>
<style lang="scss" scoped>
#section4 {
  background-color: #000;
}

#s4s1a1 {
  height: 650vh;
  #s4s1a1b1 {
    //height: 100%;
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(20vh, 6%);
    }
    .block {
      @include blockin(85%, 100%, 0%, 15%);
      p {
        @include blockinP(30%, 19%, 62%);
      }
    }
  }
  #s4s1a1b2 {
    .fake-header {
      @include fakinH(4vh, 4%);
    }
    .fake-footer {
      @include fakinF(2vh, 56%);
    }
    .block {
      @include blockin(85%, 50%, 0%, 15%);
      p {
        @include blockinP(65%, 39%, 25%);
      }
    }
  }
  #s4s1a1b3 {
    .fake-header {
      @include fakinH(4vh, 50%);
    }
    .fake-footer {
      @include fakinF(10vh, 2%);
    }
    .block {
      @include blockin(85%, 50%, 50%, 15%);
      p {
        @include blockinP(65%, 39%, 25%);
      }
    }
  }
}
#s4s1a2 {
  height: 100vh;
  #s4s1a2b1 {
    .block {
      @include blockin(85%, 100%, 0%, 15%);
      p {
        @include blockinP(30%, 16%, 62%);
      }
    }
  }
  #s4s1a2b2 {
    .block {
      @include blockin(85%, 73%, 27%, 15%);
      p {
        @include blockinP(65%, 37%, 25%);
      }
    }
  }
  #s4s1a2b3 {
    .block {
      @include blockin(85%, 100%, 0%, 15%);
      .button-list {
        @include blockinP(65%, 82%, 14%);
        position: absolute;
        button { 
          border-width: 2px;
          font-weight: 600;
          width: 190px;
          height: 73px;
          line-height: 1.1; 
        }
      }
    }
  }
}

// Medium devices 
@media (max-width: 991px) {
  #s4s1a1 {
    #s4s1a1b2 {
      .block {
        p {
          font-size: 1rem !important;
        }
      }
    }
  }
  #s4s1a2 {
    #s4s1a2b1 {
      .block {
        @include blockin(85%, 100%, 0%, 15%);
        p {
          @include blockinP(30%, 10%, 62%);
        }
      }
    }
    #s4s1a2b2 {
      .block {
        @include blockin(85%, 73%, 27%, 15%);
        p {
          @include blockinP(68%, 34%, 27%);
          font-size: 1rem !important;
        }
      }
    }
    #s4s1a2b3 {
      .block {
        .button-list {
          @include blockinP(95%, 75%, 5%);
          position: absolute;
          button { 
            border-width: 1.5px;
            font-weight: 600;
            width: 158px;
            height: 49px;
            line-height: 1.1; 
            margin-top: 0.5rem;
            font-size: 1rem !important;
          }
        }
      }
    }
  }
}

// Medium large devices
@media (min-width: 992px) and (max-width: 1399px) {
  #s4s1a2 {
    #s4s1a2b3 {
      .block {
        .button-list {
          @include blockinP(65%, 78%, 14%);
          position: absolute;
          button { 
            border-width: 2px;
            font-weight: 600;
            width: 160px;
            height: 53px;
            line-height: 1.1; 
            margin-top: 0.4rem;
          }
        }
      }
    }
  }
}
</style>